import { LatLng, LatLngTuple } from 'leaflet';
import { DeviceNodeTypeEnum } from '@/api/apis/composer';
import { AviaLegTypes, GroundLegTypes, RouteLocationType } from '@/api/apis/route';

export type Coordinate = { latitude: number; longitude: number };

export type SimpleMarkerData = {
  id: string;
  location: LatLng;
  name?: string;
  code?: string;
};

export type DeviceNodePolyline = {
  id: string;
  nodeType: DeviceNodeTypeEnum;
  plannedPositions: LatLngTuple[];
  trackedPositions: LatLngTuple[];
  isComplete: boolean;
  departureTime?: string | null;
  arrivalTime?: string | null;
};

export type ActiveNodePosition = {
  location: LatLng;
  heading: number;
  nodeType: DeviceNodeTypeEnum;
  timestamp: string;
  isActive: boolean;
};

export type LegMarkerKindEnum = 'pending-handoff' | 'completed-arrival';

export const LegMarkerKind = {
  PendingHandoff: 'pending-handoff',
  CompletedArrival: 'completed-arrival',
} as const satisfies Record<string, LegMarkerKindEnum>;

export type LegMarker =
  | { kind: typeof LegMarkerKind.PendingHandoff; id: string; location: LatLng }
  | { kind: typeof LegMarkerKind.CompletedArrival; id: string; location: LatLng; nodeType: DeviceNodeTypeEnum };

export type TransformedLocationData = {
  donorHospitalMarker: SimpleMarkerData;
  txCenterMarker: SimpleMarkerData;
  locations: RouteLocationType[];
  legs: (AviaLegTypes | GroundLegTypes)[];
  devicePolylines: DeviceNodePolyline[];
  legMarkers: LegMarker[];
  activePosition: ActiveNodePosition | null;
};
